import { useEffect } from 'react';
import type { DependencyList } from 'react';
import type { EffectCallback } from './types';

export function useEffectAsync(effect: EffectCallback, deps?: DependencyList | undefined): void {
  useEffect(() => {
    effect();
  }, deps);
}
